import { CreditCard } from "lucide-react";
import { Reveal, Eyebrow } from "./Motion";
import { CallButton } from "./CallButton";

export const CallCta = ({ eyebrow = "Your next flight starts here", title = ["A better trip starts", "with a real conversation."], text = "Compare airlines, travel dates and fare options with a flight specialist." }) => (
  <section className="border-y border-brand/10 bg-brand-soft py-14" data-testid="call-cta">
    <Reveal className="mx-auto flex max-w-[1320px] flex-col justify-between gap-6 px-4 sm:px-8 md:flex-row md:items-center">
      <div>
        <Eyebrow>{eyebrow}</Eyebrow>
        <h2 className="mt-3 font-display text-2xl font-bold leading-snug text-ink sm:text-3xl">{title[0]}<br />{title[1]}</h2>
        <p className="mt-3 text-slate-600">{text}</p>
      </div>
      <CallButton testId="call-cta-btn" label="Call now" size="lg" />
    </Reveal>
  </section>
);

const PAY = [["visa", "Visa"], ["mastercard", "Mastercard"], ["amex", "American Express"], ["discover", "Discover"]];

export const PaymentOptions = () => (
  <section className="bg-sand py-10" data-testid="payment-options">
    <div className="mx-auto flex max-w-[1320px] flex-col justify-between gap-6 px-4 sm:px-8 md:flex-row md:items-center">
      <div className="flex items-center gap-4">
        <span className="grid h-12 w-12 place-items-center rounded-xl border border-slate-200 bg-white text-ink"><CreditCard className="h-5 w-5" /></span>
        <div>
          <Eyebrow className="!text-slate-500">Payment options</Eyebrow>
          <h2 className="font-display text-xl font-bold text-ink">Your trip. Your way to pay.</h2>
          <p className="text-xs text-slate-600">Confirm your total and payment details with our team.</p>
        </div>
      </div>
      <div>
        <p className="mb-2 text-xs text-slate-500">We accept</p>
        <div className="flex flex-wrap gap-2.5">
          {PAY.map(([k, n]) => (
            <img key={k} src={`/pay/${k}.svg`} alt={n} title={n} data-testid={`pay-logo-${k}`}
              className="h-10 w-16 rounded-md shadow-sm ring-1 ring-slate-200 transition-transform duration-300 hover:-translate-y-1" />
          ))}
        </div>
      </div>
    </div>
  </section>
);
